import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nomClient", "numTelClient", "submitButton", "fakeButton"]

  connect() {
  }

  validateForm() {
    const testNom = this.testName(this.nomClientTarget.value);
    const testNum = this.testPhoneNumber(this.numTelClientTarget.value);

    if (testNom && testNum) {
      this.submitButtonTarget.style.display = "block";
      this.fakeButtonTarget.style.display = "none";
    } else {
      this.submitButtonTarget.style.display = "none";
      this.fakeButtonTarget.style.display = "block";
    }
  }

  testName(name) {
    return name.length >= 2;
  }

  testPhoneNumber(phoneNumber) {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    return digitsOnly.length >= 9;
  }
}